import React from "react";
import SettingsTabs from "./Settings Tabs/SettingsTabs";
import UserSection from "./UserSection";

const SettingsDashboard = ({ containerMaxWidth }) => {
  return (
    <>
      <section
        style={{ width: `calc(100% - ${containerMaxWidth}px)` }}
        className="min-h-screen  flex flex-col"
      >
        <UserSection />

        <div className="bg-gray-50 h-full">
          <div className="flex flex-col px-8">
            <h1 className="text-xl text-gray-800 font-bold pt-8">Settings</h1>
            <SettingsTabs />
          </div>
        </div>
      </section>
    </>
  );
};

export default SettingsDashboard;
